"use client";
import { ReactNode } from "react";
import withSession from "../../../hoc/withSession";
const ProfileLayout = ({ children }): ReactNode => {
  return <>{children}</>;
};

export default withSession(ProfileLayout, "/");
